@if(!isFinished){
    <div class="container pt-3 fade-in-left" id="centerFrame">
        <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
            <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
            <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Eliminar Cuenta</h1></div>
        </div>

        <!-- Sections -->
        <div class="row-cols-12 m-4 ">
            <form (ngSubmit)="deleteAccount()" [formGroup]="moreEliminarCuenta">
                <div class="row p-3">
                    <h4 class="mb-3">Solicitar eliminación de datos</h4>
                    <p>Si deseas eliminar tu cuenta y todos tus datos personales de nuestro sistema, por favor completa el siguiente formulario. Procesaremos tu solicitud a la brevedad.</p>
                </div>
                <div class="col">
                    <label for="validar" class="form-label">Para confirmar, escriba <strong>"ELIMINAR"</strong> en el siguiente campo</label>
                    <input type="text" class="form-control" formControlName="validar" value="{{validar}}">
                    @if (moreEliminarCuenta.controls['validar'].invalid && (moreEliminarCuenta.controls['validar'].dirty || moreEliminarCuenta.controls['validar'].touched) && moreEliminarCuenta.controls['validar'].errors?.['required']) {
                        <div class="alert-danger" role="alert"><small class="alert">La verificación es requerida</small></div>
                    }
                </div>
                @if (error()) {
                    <div class="alert alert-danger mt-2" role="alert">
                        <small>{{ error() }}</small>
                    </div>
                }
                <div class="d-grid mt-4 mb-3 pb-3">
                    <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">{{(loading()) ? 'Cargando...' : 'Eliminar mi cuenta y todos mis datos'}}</button>
                </div>
            </form>
        </div>
    </div>
}
@if(isFinished){
    <div class="container mt-5 fade-in-left" id="centerFrameTwo">
        <div class="row p-3 mb-3 mt-5 align-items-center">
            <!-- Sections -->
            
            <div class="mt-5">
                <div class="row form-switch ps-0 mb-3">
                    <div class="col text-center sucess-text mt-5 mb-5">
                        <b><span class="bluetext"><strong>Tu solicitud fue enviada.</strong></span><br>Te notificaremos a la brevedad</b>
                    </div>
                </div>
            </div>
            
            <div class="d-grid mt-3 mb-3 pb-3">
                <button type="button" class="btn btn-primary btn-lg mt-0" (click)="logout()">Salir</button>
            </div>
        </div>
    </div>
}
